import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=50df4ef4"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50df4ef4')) {
      api.createRecord('50df4ef4', component.options)
    } else {
      api.reload('50df4ef4', component.options)
    }
    module.hot.accept("./wizard.vue?vue&type=template&id=50df4ef4", function () {
      api.rerender('50df4ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/wizard.vue"
export default component.exports